import { useEffect } from 'react';
import { useCustomersLookupStore, useCustomersStore } from '@lib';
import { useDebounce } from './useDebounce';

export const useLookupCustomer = (text: string) => {
  const { loading, customers, getCustomers } = useCustomersStore();

  const search = useDebounce(text, 500);

  useEffect(() => {
    if (!search || search.length < 2) return;

    getCustomers({ fullName: search });
  }, [search]);

  return { loading, customers };
};

export const useLookupText = (value?: string, text?: string) => {
  const { loading, customers, getCustomers, clear } = useCustomersLookupStore();

  useEffect(() => {
    if (text) {
      clear();
      return;
    }

    if (!!value && !text) {
      getCustomers({ custCode: value });
    }
  }, [text]);

  return { loading, customers };
};
